import React from 'react';
import PageHeader from './components/PageHeader';
import DialogFooter from './components/DialogFooter';
import { useAnimatedClose } from './hooks/useAnimatedClose';

export default function ConfirmDialog({ title, message, onConfirm, onCancel, confirmLabel = 'Confirm', cancelLabel = 'Cancel', testId }) {
  const { close, isClosing } = useAnimatedClose(onCancel);

  return (
    <div className={`stack page-slide-in${isClosing ? ' page-slide-out' : ''}`} data-testid={testId || undefined}>
      <PageHeader
        title={title}
        subtitle="Confirm"
        actions={(
          <button className="button secondary" onClick={close} data-testid={testId ? `${testId}-close` : undefined}>Back</button>
        )}
      />

      <div className="drawer-body">
        <div className="drawer-preview">
          <div className="card" style={{ padding: 16 }}>
            <div className="muted" style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>Preview</div>
            <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 8 }}>{title || 'Confirmation'}</div>
            <div className="muted" style={{ fontSize: 13, lineHeight: 1.4 }}>{message || '—'}</div>
            <div className="divider" style={{ margin: '12px 0' }} />
            <div className="muted" style={{ fontSize: 12 }}>You’re about to proceed with this action.</div>
          </div>
        </div>
        <div className="drawer-controls">
          <div className="drawer-controls-card">
            <div className="stack" style={{ gap: 12, marginBottom: 20 }}>
              <div data-testid={testId ? `${testId}-message` : undefined}>{message}</div>
            </div>
            <DialogFooter>
              <button className="button secondary" onClick={close} data-testid={testId ? `${testId}-cancel` : undefined}>{cancelLabel}</button>
              <button className="button" onClick={onConfirm} data-testid={testId ? `${testId}-confirm` : undefined}>{confirmLabel}</button>
            </DialogFooter>
          </div>
        </div>
      </div>
    </div>
  );
}
